import React from 'react';
import { Box, Switch, Typography } from '@mui/material';


export default function ReceiptTypeSwitch({ value, onChange, disabled = false }) {
  const isFuel = value === 'fuel';

  return (
    <Box
      role="group"
      aria-label="Receipt type"
      sx={{
        alignItems: 'center',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'center',
        minHeight: 48,
        px: 2,
        width: '100%',
      }}
    >
      <Typography color={isFuel ? 'text.secondary' : 'primary'} fontWeight={isFuel ? 400 : 600}>
        Groceries
      </Typography>
      <Switch
        checked={isFuel}
        disabled={disabled}
        inputProps={{ 'aria-label': 'Use fuel receipt mode' }}
        onChange={(event) => onChange(event.target.checked ? 'fuel' : 'grocery')}
      />
      <Typography color={isFuel ? 'primary' : 'text.secondary'} fontWeight={isFuel ? 600 : 400}>
        Fuel
      </Typography>
    </Box>
  );
}
